import React from "react";
import {
  CardHeader,
  Grid,
  IconButton,
  makeStyles,
  Typography,
} from "@material-ui/core";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Collapse from "@material-ui/core/Collapse";
import CardContent from "@material-ui/core/CardContent";
import { Labeled } from "react-admin";
import Card from "@material-ui/core/Card";
import { IRoutePricePreview } from "./RoutePriceComponent";
import { calculateTotal } from "../tools";
import Tooltip from "@material-ui/core/Tooltip";

interface IPricePreviewCard {
  vehicleSize: string;
  index: number;
  lastData?: IRoutePricePreview;
  currentData?: IRoutePricePreview;
  expanded: boolean;
  onToggle: () => void;
}

const useStyles = makeStyles({
  cardMargin: {
    marginBottom: 8,
  },
  cardSectionPadding: {
    padding: "0px 8px",
  },
  cardHeaderAction: {
    marginTop: "0px",
  },
});

const RoutePricePreviewCard = ({
  vehicleSize,
  index,
  lastData,
  currentData,
  expanded,
  onToggle,
}: IPricePreviewCard) => {
  const classes = useStyles();

  const formatCurrency = (value?: number) =>
    value != null ? `$ ${(value / 100).toFixed(2)}` : "-";

  const key = `${vehicleSize}-${index}`;

  return (
    <Card key={key} variant="outlined" className={classes.cardMargin}>
      <CardHeader
        title={`${vehicleSize.charAt(0).toUpperCase()}${vehicleSize.slice(
          1,
        )} Vehicle`}
        titleTypographyProps={{ variant: "subtitle1" }}
        action={
          <Tooltip title={expanded ? "Hide details" : "Show details"}>
            <IconButton onClick={onToggle} size="small">
              {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </IconButton>
          </Tooltip>
        }
        classes={{
          root: classes.cardSectionPadding,
          action: classes.cardHeaderAction,
        }}
      />
      <Collapse in={expanded} unmountOnExit>
        <CardContent className={classes.cardSectionPadding}>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <Typography variant="subtitle2">
                Last Month Price Preview
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="subtitle2">New Price Preview</Typography>
            </Grid>

            {[lastData, currentData].map((entry, sideIndex) => (
              <Grid key={`${key}-preview-${sideIndex}`} item xs={6}>
                <Grid item xs={12}>
                  <Labeled label="Base Amount">
                    <Typography variant="body2">
                      {formatCurrency(entry?.baseAmount)}
                    </Typography>
                  </Labeled>

                  <Labeled
                    label={
                      sideIndex === 0
                        ? "Old Adjustment Amount"
                        : "New Adjustment Amount"
                    }
                  >
                    <Typography
                      variant="body2"
                      style={{
                        color:
                          lastData?.adjustmentAmount !==
                            currentData?.adjustmentAmount && sideIndex === 1
                            ? "green"
                            : "inherit",
                      }}
                    >
                      {formatCurrency(entry?.adjustmentAmount)}
                    </Typography>
                  </Labeled>

                  <Labeled label="BA Incentive">
                    <Typography variant="body2">
                      {formatCurrency(entry?.busAssistantIncentive)}
                    </Typography>
                  </Labeled>

                  <Labeled label="Additional Incentive">
                    <Typography variant="body2">
                      {formatCurrency(entry?.additionalIncentive)}
                    </Typography>
                  </Labeled>

                  <Labeled label="School Incentive">
                    <Typography variant="body2">
                      {formatCurrency(entry?.schoolIncentive)}
                    </Typography>
                  </Labeled>

                  <Labeled label="Total">
                    <Typography
                      variant="body2"
                      style={{
                        color:
                          lastData?.adjustmentAmount !==
                            currentData?.adjustmentAmount && sideIndex === 1
                            ? "green"
                            : "inherit",
                      }}
                    >
                      {formatCurrency(calculateTotal(entry))}
                    </Typography>
                  </Labeled>
                </Grid>
              </Grid>
            ))}
          </Grid>
        </CardContent>
      </Collapse>
    </Card>
  );
};

export default RoutePricePreviewCard;
